export * from './quillEditor.module';



// WEBPACK FOOTER //
// D:/projects/4164_AppsPotr_Backend/production/CMS_prod/node_modules/ngx-quill-editor/index.ts